const Flickity = require('flickity');
import {slideUp, slideDown} from "es6-slide-up-down";

import findAncestor from "./findAncestor";

export default () => {

    let sliders = [];
    const valueSlides = document.querySelectorAll('[data-value-slider]');

    const isMobile = () => {
        return window.innerWidth < 768;
    }

    const openValue = (value, container, popupContainer, open) => {
        const popup = value.parentNode.querySelector('.values__popup');
        container.innerHTML = popup.innerHTML;

        const close = container.querySelector('.close');

        popupContainer.classList.add('active');
        // if (open && isMobile()) {
        //     slideDown(popupContainer, {
        //         duration: 500,
        //         startAsHeight: true
        //     });
        // }
        //
        if (close) {
            close.addEventListener('click', () => {
                popupContainer.classList.remove('active');
            });
        }
    }

    const init = () => {
        for (const valueSlide of valueSlides) {
            const container = findAncestor(valueSlide, '[data-container]');
            const mobilePopupContainer = container.querySelector('[data-popup-container]');
            const mobilePopup = mobilePopupContainer.querySelector('.values__popup');
            const back = container.querySelector('[data-popup-close]');
            const next = container.querySelector('[data-next]');
            const prev = container.querySelector('[data-prev]');

            let flickity = null;
            if (isMobile()) {
                flickity = new Flickity(valueSlide, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    pageDots: true
                });
                sliders.push(flickity);
                flickity.on('change', function( index ) {
                    if (valueSlide.getAttribute('data-opened') == 1) {
                        openValue(
                            flickity.selectedElement.querySelector('.value__inner'),
                            mobilePopup,
                            mobilePopupContainer
                        );
                    }
                });

                next.addEventListener('click', (e) => {
                    e.preventDefault();
                    flickity.next();
                });

                prev.addEventListener('click', (e) => {
                    e.preventDefault();
                    flickity.previous();
                });
            }

            const triggers = valueSlide.querySelectorAll('.value__inner');
            for (const trigger of triggers) {
                trigger.addEventListener('click', () => {
                    valueSlide.setAttribute('data-opened', 1);
                    openValue(trigger, mobilePopup, mobilePopupContainer, true);
                });
            }

            back.addEventListener('click', (e) => {
                e.preventDefault();
                valueSlide.setAttribute('data-opened', 0);
                mobilePopupContainer.classList.remove('active');
                // if (isMobile()) {
                //     slideUp(mobilePopupContainer, {
                //         duration: 500
                //     });
                // }
            });
        }
    }

    const destroy = () => {
        if (sliders.length) {
            for (const slider of sliders) {
                slider.destroy();
            }
        }
        sliders = [];
    }

    const check = () => {
        init();
        if (window.innerWidth >= 768) {
            destroy();
        }
    }

    if (valueSlides.length) {
        check();
        window.addEventListener('resize', () => {
            check();
        });
    }

}
